<p class="message" role="status" aria-live="polite">
  @if (!isOnline()) {
    Sin conexión. Revisá tu internet; vamos a reintentar cuando vuelva.
  }
</p>
